import { useEffect, useState } from 'react';
import AOS from 'aos';
import PricingCard from '../ui/PricingCard';
import { FaEnvelope, FaWhatsapp, FaCheckCircle, FaExclamationTriangle } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import LoadingButton from '../utils/Loading';
import LoadingAction from '../utils/LoadingAction';

const plans = [
  {
    title: 'Starter',
    description: 'Perfect for portfolios and small businesses.',
    features: [
      'Landing Page',
      'Responsive Design',
      'Contact Form',
      'SEO Basics',
      '2 Free Revisions',
      'Delivery: 5-7 Days',
    ],
    price: 'Starting from ₹4,999',
    isPopular: false,
  },
  {
    title: 'Business',
    description: 'Ideal for growing businesses.',
    features: [
      'Multi-page Website',
      'Admin Panel',
      'Authentication',
      'Deployment',
      'SEO Optimization',
      '3 Free Revisions'
    ],
    price: 'Starting from ₹12,999',
    isPopular: true,
  },
  {
    title: 'Custom MERN Application',
    description: 'Tailored for unique business requirements.',
    features: [
      'Fully Customized Solution',
      'React, Node.js, Express, MongoDB',
      'Authentication',
      'REST APIs',
      'Database Design',
      'Deployment',
      'Unlimited revisions during development'
    ],
    price: "Let's Discuss",
    isPopular: false,
  },
];

const PricingSection = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [whatLoading, setWhatLoading] = useState(false);

  useEffect(() => {
    AOS.refresh();
  }, []);

  return (
    <section className="section mb-0" id="pricing" style={{ background: '#f9f9f9' }}>
      <div>
        <div className="text-center mb-5" data-aos="fade-up">
          <h2 className="section-title">Pricing Plans</h2>
          <p className="section-subtitle">
            Transparent pricing for your web development needs. Choose a plan that fits your project.
          </p>
        </div>

        <div className="row justify-content-center mx-5">
          {plans.map((plan, index) => (
            <PricingCard
              key={index}
              title={plan.title}
              description={plan.description}
              features={plan.features}
              price={plan.price}
              isPopular={plan.isPopular}
              delay={index * 100}
            />
          ))}
        </div>

        <div className="text-center mt-3 mb-4">
          <small className="text-muted">
            *Final pricing may vary depending on project requirements.
          </small>
        </div>

        <div className="pricing-info-box" data-aos="fade-up" data-aos-delay="300">
          <h4 className="info-title">Need a Custom Solution?</h4>
          <p className="info-text">
            Every project is unique.
            <br />
            Let's discuss your requirements and I'll provide a custom quote tailored to your needs.
          </p>
          <div className="info-details">
            <div className="info-item">
              <FaCheckCircle size={18} className="info-icon success" />
              <span>FREE Consultation</span>
            </div>
            <div className="info-item">
              <FaCheckCircle size={18} className="info-icon success" />
              <span>FREE Website Review & Improvement Suggestions </span>
            </div>
            <div className="info-item">
              <FaCheckCircle size={18} className="info-icon success" />
              <span>Flexible milestone payments</span>
            </div>
            <div className="info-item">
              <FaExclamationTriangle size={18} className="info-icon warning" />
              <span>Final development cost depends on project scope.</span>
            </div>
          </div>
          <div className="info-buttons">
            <LoadingButton
             className="btn btn-primary rounded-pill shadow hire-btn"
             isLoading={loading}
             onClick={() => 
              LoadingAction(
                setLoading,
                () => navigate("/#contact"),
              )
             } 
            >
              <FaEnvelope size={18} className="mr-2" />
              Send Email
            </LoadingButton>
            <LoadingButton
              isLoading={whatLoading}
              onClick={() =>
                LoadingAction(
                  setWhatLoading,
                  () => {
                    const newWindow = window.open(
                      "https://wa.me/918982896759?text=Hi%20Tehzeeb,%20I%20visited%20your%20portfolio%20and%20would%20like%20to%20discuss%20a%20project.", 
                      "_blank", 
                      "noopener,noreferrer"
                    );

                    if (newWindow) {
                      newWindow.opener = null;
                    }
                  }
                )
              }
              className="btn btn-outline-primary rounded-pill shadow service-btn"
            >
              <FaWhatsapp size={18} className="mr-2" />
              WhatsApp Me
            </LoadingButton>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
